const getters = {
  scBonuses: state => state.sc_bonuses,
  scBonus: state => state.sc_bonus,
  scBonusTypes: state => state.sc_bonus_types,
  scBonusCalculationTypes: state => state.sc_bonus_calculation_types,
  scBonusFilters: state => state.sc_bonus_filters,
}

export default getters;
